import React from 'react';
import { useTheme } from 'styled-components';

export const SwitchSvg = (props) => {
  const { disabled, color, checked, small } = props;

  const theme = useTheme();

  if (checked) {
    return (
      <svg width={small ? "28" : "40"} height={small ? "17" : "23"} viewBox="0 0 40 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="23" rx="11.5" fill={disabled ? "#E3E3E3" : color ? color : theme?.colour?.primary ?? "#1DBD6B"} />
        <circle cx="28.2593" cy="11.3008" r="8" fill="white" />
      </svg>
    )
  } else {
    return (
      <svg width={small ? "28" : "40"} height={small ? "17" : "23"} viewBox="0 0 40 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="23" rx="11.5" fill={"#E3E3E3"} />
        <circle cx="12.2593" cy="11.3008" r="8" fill="white" />
      </svg>
    )
  }
}